import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';

import { PendingVibeUpdatePicker } from './PendingVibeUpdatePicker';

export const PendingVibeUpdatePickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'PendingVibeUpdatePicker',
    component: PendingVibeUpdatePicker,
  }),
);
